import { render, staticRenderFns } from "./profilesView.vue?vue&type=template&id=0bd61ea3&scoped=true"
import script from "./profilesView.vue?vue&type=script&lang=js"
export * from "./profilesView.vue?vue&type=script&lang=js"
import style0 from "./profilesView.vue?vue&type=style&index=0&id=0bd61ea3&prod&lang=scss&scoped=true"
import style1 from "./profilesView.vue?vue&type=style&index=1&id=0bd61ea3&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd61ea3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconProfMenu: require('/app/components/icons/dashboard/IconProfMenu.vue').default,MySwitch: require('/app/components/global/my-switch.vue').default,Catalog: require('/app/components/catalog/catalog.vue').default,IconDotsWBg: require('/app/components/icons/IconDotsWBg.vue').default,SliderForComments: require('/app/components/index/slider-for-comments.vue').default,VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,IconNoteEye: require('/app/components/v2/icons/IconNoteEye.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
